import { TemplateParams } from "@hakit/core";
export function DummyComponentOptions(props: Partial<TemplateParams>) {
  return props;
}
